import { Stack } from '@mui/material';
import React, { FC } from 'react';

import { IMedia, MediaType } from '../../interfaces/common';

import PhotoItem from './photo.item';
import VideoItem from './video.item';

interface MediaContentProps {
  media: IMedia[];
  selectedMedia: IMedia[];
  onSelectMedia: (newMedia: IMedia) => void;
  onDelete: (mediaId: string) => void;
}

const MediaContent: FC<MediaContentProps> = ({
  media,
  selectedMedia,
  onSelectMedia,
  onDelete,
}) => {
  return (
    <Stack
      sx={{
        width: '100%',
        height: '224px',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
          display: 'block',
          backgroundColor: 'gray',
          width: '6px',
        },
      }}
    >
      <Stack
        direction="row"
        gap="12px"
        sx={{
          flexWrap: 'wrap',
          mb: '20px',
          p: '0 8px',
        }}
      >
        {media.map((media) => {
          const selectedIds = selectedMedia.map(({ _id }) => _id);
          const isSelected = selectedIds.includes(media._id);

          const number = selectedIds.indexOf(media._id) + 1;

          switch (media.type) {
            case MediaType.photo: {
              return (
                <PhotoItem
                  media={media}
                  isSelected={isSelected}
                  onSelectMedia={onSelectMedia}
                  number={number}
                  onDelete={() => onDelete(media._id)}
                />
              );
            }

            case MediaType.video: {
              return (
                <VideoItem
                  media={media}
                  isSelected={isSelected}
                  onSelectMedia={onSelectMedia}
                  number={number}
                  onDelete={() => onDelete(media._id)}
                />
              );
            }
          }
        })}
      </Stack>
    </Stack>
  );
};

export default MediaContent;
